
export default {
  data: () => ({
    validationRules: {
      required: [
        v => !!v || 'This field is required',
      ],
      email: [
        v => {
          if (!v) return true
          return (
            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(v) ||
            'Invalid email address'
          )
        },
      ],
    },
  }),
}



// WEBPACK FOOTER //
// ./src/mixins/forms.js